import React, { useState } from "react";
import "./AddPartnerForm.css";

const API_URL = `/api/partners`;

const AddPartnerForm = ({ onClose, onPartnerAdded }) => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name) {
      setError("Partner name is required.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      console.log('🎨 Adding partner to:', API_URL, formData);

      const response = await fetch(API_URL, {   // ✅ uses top-level constant
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP ${response.status}: Failed to add Partner`);
      }

      console.log('✅ Partner added:', data);
      alert("✅ Partner added successfully!");

      setTimeout(() => {
        onPartnerAdded();
        onClose();
      }, 300);
    } catch (error) {
      console.error("❌ Error adding partner:", error);
      setError(error.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose} disabled={loading}>✖</button>

        <h3>Add Partner</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="partner-name">Partner Name:</label>
            <input
              id="partner-name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="partner-code">Partner Code:</label>
            <input
              id="partner-code"
              type="text"
              name="number"
              value={formData.number}
              onChange={handleChange}
              placeholder="#000000 or rgb(0,0,0)"
              disabled={loading}
            />
            {formData.number && formData.number.startsWith('#') && (
              <div
                style={{
                  width: '50px',
                  height: '30px',
                  backgroundColor: formData.number,
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  marginTop: '8px'
                }}
                title="Partner preview"
              />
            )}
          </div>

          {error && (
            <p className="error-message" style={{
              color: '#c33',
              padding: '10px',
              backgroundColor: '#fee',
              borderRadius: '4px'
            }}>
              ⚠️ {error}
            </p>
          )}

          <button
            type="submit"
            className="submit-btn"
            disabled={loading}
          >
            {loading ? 'Adding...' : 'Add Partner'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPartnerForm;